import { CartSheet } from "@/components/CartSheet";
import { NotificationBell } from "@/components/NotificationBell";

interface NavbarIconsProps {
  user: any;
  cartOpen: boolean;
  onCartOpenChange: (open: boolean) => void;
}

export const NavbarIcons = ({ user, cartOpen, onCartOpenChange }: NavbarIconsProps) => {
  return (
    <div className="flex items-center gap-2">
      <CartSheet open={cartOpen} onOpenChange={onCartOpenChange} />
      
      {user && <NotificationBell />}
    </div>
  );
};
